const allHomepageStepsContentDropdown = document.querySelectorAll(
  '#homepage-steps-content-dropdown'
);

for (var i = 0; i < allHomepageStepsContentDropdown.length; i++)
  (function (i) {
    allHomepageStepsContentDropdown[i].onclick = function (event) {
      var parent = allHomepageStepsContentDropdown[i].parentNode;
      parent.classList.toggle("open");
    };
  })(i);




/**
 * @file
 * Behaviors for the Carousel.
 */

 !((Drupal, $) => {
  'use strict';

  /**
   * Setup and attach the Carousel behaviors.
   *
   * @type {Drupal~behavior}
   */
  Drupal.behaviors.carousel = {
    attach: function() {
      $('.homepage-connect-container').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3500,
        draggable: false,
        dots: true,
        arrows: false,
        speed: 500,
        fade: true,
        fadeSpeed: 1000,
        cssEase: 'linear'
      });
      $('.homepage-product__body').slick({
        dots: false,
        infinite: false,
        speed: 300,
        draggable: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              nextArrow:`<svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="25" cy="25" r="20" fill="#F5FFFD"/>
              <path d="M20.1695 16.68C20.0634 16.8662 20.005 17.0757 19.9995 17.29L19.9995 17.47C20.0707 17.8292 20.2567 18.1556 20.5295 18.4V18.4L27.4895 24.93C25.1962 27.07 22.9062 29.2233 20.6195 31.39L20.5495 31.45L20.4695 31.53C20.3677 31.6223 20.286 31.7347 20.2295 31.86V31.86C20.0956 32.0923 20.0169 32.3524 19.9995 32.62L19.9995 32.69C20.0196 32.9729 20.1263 33.2428 20.3053 33.4629C20.4842 33.683 20.7266 33.8426 20.9995 33.92V33.92C21.1744 33.9738 21.3565 34.0008 21.5395 34C21.6611 33.9981 21.782 33.9813 21.8995 33.95V33.95C22.171 33.878 22.4191 33.7368 22.6195 33.54V33.54L24.8495 31.43C26.7095 29.68 28.5595 27.93 30.4295 26.2C30.609 26.0396 30.7526 25.8431 30.8509 25.6234C30.9492 25.4037 31 25.1657 31 24.925C31 24.6843 30.9492 24.4463 30.8509 24.2266C30.7526 24.0069 30.609 23.8104 30.4295 23.65V23.65C28.8695 22.2 27.3095 20.73 25.7595 19.27L22.6295 16.33L22.5595 16.27L22.4895 16.21C22.199 15.9855 21.8378 15.8722 21.471 15.8905C21.1043 15.9089 20.7562 16.0576 20.4895 16.31V16.31L20.3395 16.51L20.1895 16.71L20.1695 16.68Z" fill="#00C4B3"/>
              </svg>                                
              `,
              prevArrow:`<svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="25" cy="24" r="20" transform="rotate(-180 25 24)" fill="#F5FFFD"/>
              <path d="M29.8305 32.32C29.9366 32.1338 29.995 31.9243 30.0005 31.71V31.53C29.9293 31.1708 29.7433 30.8444 29.4705 30.6V30.6L22.5105 24.07C24.8038 21.93 27.0938 19.7767 29.3805 17.61L29.4505 17.55L29.5305 17.47C29.6323 17.3777 29.714 17.2653 29.7705 17.14V17.14C29.9044 16.9077 29.9831 16.6476 30.0005 16.38V16.31C29.9804 16.0271 29.8737 15.7572 29.6947 15.5371C29.5158 15.317 29.2734 15.1574 29.0005 15.08V15.08C28.8256 15.0262 28.6435 14.9992 28.4605 15C28.3389 15.0019 28.218 15.0187 28.1005 15.05V15.05C27.829 15.122 27.5809 15.2632 27.3805 15.46V15.46L25.1505 17.57C23.2905 19.32 21.4405 21.07 19.5705 22.8C19.391 22.9604 19.2474 23.1569 19.1491 23.3766C19.0508 23.5963 19 23.8343 19 24.075C19 24.3157 19.0508 24.5537 19.1491 24.7734C19.2474 24.9931 19.391 25.1896 19.5705 25.35V25.35C21.1305 26.8 22.6905 28.27 24.2405 29.73L27.3705 32.67L27.4405 32.73L27.5105 32.79C27.801 33.0145 28.1622 33.1278 28.529 33.1095C28.8957 33.0911 29.2438 32.9424 29.5105 32.69V32.69L29.6605 32.49L29.8105 32.29L29.8305 32.32Z" fill="#00C4B3"/>
              </svg>                           
              `
            }
          },
          {
            breakpoint: 780,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              arrows: false,
              draggable: true,
              dots: true,
            }
          },
          {
            breakpoint: 544,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              arrows: false,
              draggable: true,
              dots: true,
            }
          },
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ],
        nextArrow:`<svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="25" cy="25" r="20" fill="#F5FFFD"/>
          <path d="M20.1695 16.68C20.0634 16.8662 20.005 17.0757 19.9995 17.29L19.9995 17.47C20.0707 17.8292 20.2567 18.1556 20.5295 18.4V18.4L27.4895 24.93C25.1962 27.07 22.9062 29.2233 20.6195 31.39L20.5495 31.45L20.4695 31.53C20.3677 31.6223 20.286 31.7347 20.2295 31.86V31.86C20.0956 32.0923 20.0169 32.3524 19.9995 32.62L19.9995 32.69C20.0196 32.9729 20.1263 33.2428 20.3053 33.4629C20.4842 33.683 20.7266 33.8426 20.9995 33.92V33.92C21.1744 33.9738 21.3565 34.0008 21.5395 34C21.6611 33.9981 21.782 33.9813 21.8995 33.95V33.95C22.171 33.878 22.4191 33.7368 22.6195 33.54V33.54L24.8495 31.43C26.7095 29.68 28.5595 27.93 30.4295 26.2C30.609 26.0396 30.7526 25.8431 30.8509 25.6234C30.9492 25.4037 31 25.1657 31 24.925C31 24.6843 30.9492 24.4463 30.8509 24.2266C30.7526 24.0069 30.609 23.8104 30.4295 23.65V23.65C28.8695 22.2 27.3095 20.73 25.7595 19.27L22.6295 16.33L22.5595 16.27L22.4895 16.21C22.199 15.9855 21.8378 15.8722 21.471 15.8905C21.1043 15.9089 20.7562 16.0576 20.4895 16.31V16.31L20.3395 16.51L20.1895 16.71L20.1695 16.68Z" fill="#00C4B3"/>
          </svg>                                
          `,
        prevArrow:`<svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="25" cy="24" r="20" transform="rotate(-180 25 24)" fill="#F5FFFD"/>
        <path d="M29.8305 32.32C29.9366 32.1338 29.995 31.9243 30.0005 31.71V31.53C29.9293 31.1708 29.7433 30.8444 29.4705 30.6V30.6L22.5105 24.07C24.8038 21.93 27.0938 19.7767 29.3805 17.61L29.4505 17.55L29.5305 17.47C29.6323 17.3777 29.714 17.2653 29.7705 17.14V17.14C29.9044 16.9077 29.9831 16.6476 30.0005 16.38V16.31C29.9804 16.0271 29.8737 15.7572 29.6947 15.5371C29.5158 15.317 29.2734 15.1574 29.0005 15.08V15.08C28.8256 15.0262 28.6435 14.9992 28.4605 15C28.3389 15.0019 28.218 15.0187 28.1005 15.05V15.05C27.829 15.122 27.5809 15.2632 27.3805 15.46V15.46L25.1505 17.57C23.2905 19.32 21.4405 21.07 19.5705 22.8C19.391 22.9604 19.2474 23.1569 19.1491 23.3766C19.0508 23.5963 19 23.8343 19 24.075C19 24.3157 19.0508 24.5537 19.1491 24.7734C19.2474 24.9931 19.391 25.1896 19.5705 25.35V25.35C21.1305 26.8 22.6905 28.27 24.2405 29.73L27.3705 32.67L27.4405 32.73L27.5105 32.79C27.801 33.0145 28.1622 33.1278 28.529 33.1095C28.8957 33.0911 29.2438 32.9424 29.5105 32.69V32.69L29.6605 32.49L29.8105 32.29L29.8305 32.32Z" fill="#00C4B3"/>
        </svg>                           
        `
      });
    }
  };
})(Drupal, jQuery);
